import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TokenService } from './token.service';
import { ILogin } from '../models/login';
import { environment } from '../../../../environments/environment';
import { ILoginResponse } from '../models/login.response';
import { map, tap } from 'rxjs';
import { JwtDecoderService } from './jwt-decoder.service';
import { Router } from '@angular/router';
import { URLS } from '../../../shared/constants/urls';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  apiUrl = environment.apiURL;
  constructor(
    private http: HttpClient,
    private tokenService: TokenService,
    private router: Router,
    private jwtDecoderService: JwtDecoderService
  ) {}

  login (data: ILogin) {
    return this.http.post<ILoginResponse>(this.apiUrl + '/api/login_check', data).pipe(
      map((response:ILoginResponse) => {
        if (response.token) {
          const user = this.jwtDecoderService.decodeToken(response.token);
          this.tokenService.setToken(response.token, user.roles[0], response.refresh_token);
        }
        return response;
      })
    );
  }

  refreshToken() {
    return this.http.post<ILoginResponse>(this.apiUrl + '/api/token/refresh', {
      refresh_token: this.tokenService.getRefreshToken()
    }).pipe(
      map((response: ILoginResponse) => {
        this.tokenService.setAccessToken(response.token, response.refresh_token);
        return response;
      })
    );
  }

  resetPassword(email: string) {
    return this.http.post(this.apiUrl + '/api/register/reset_password', { email });
  }

  logout() {
    this.tokenService.removeToken();
    this.router.navigateByUrl(URLS.AUTH);
  }

  confirmAccount(token: string) {
    return this.http.get(this.apiUrl + `/register/validate_email/${token}`);
  }
}
